import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IApiSettings } from '@interfaces';
import { ApiResponse } from '@shared';

@Injectable({
  providedIn: 'root',
})
export class ApiSettingsService {
  constructor(private http: HttpClient) {}
  getApiSettings() {
    return this.http.get<ApiResponse>('/v1/admin/api-settings');
  }
  createApiSettings(apiSettingsData: IApiSettings) {
    return this.http.post<ApiResponse>('/v1/admin/api-settings', apiSettingsData);
  }
  updateApiSettings(id: string | null, apiSettingsData: IApiSettings) {
    return this.http.put<ApiResponse>(`/v1/admin/api-settings/${id}`, apiSettingsData);
  }
}
